import React from 'react'
import PropTypes from 'prop-types'
import BlockUi from 'react-block-ui'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import ConfirmationModal from '../../../form/component/ConfirmationModal'
import InvoiceItemCorrectionForm from './InvoiceItemCorrectionForm'
import LabelInput from '../../../form/component/LabelInput'
import TextArea from '../../../form/component/TextArea'

const InvoiceCorrectionForm = ({ invoice, fetching, invoiceCorrectionData, confirmationModalOpen, changeInvoiceCorrectionData, changeInvoiceCorrectionItem, createInvoiceCorrection, showConfirmationModal, closeConfirmationModal }) => {
    return (
        <BlockUi tag="div" blocking={fetching}>

            <ContentBox title={'Create Invoice Correction ' + invoice.referenceNumber}>

                <ConfirmationModal
                    showModal={confirmationModalOpen}
                    confirmClicked={createInvoiceCorrection}
                    cancelClicked={closeConfirmationModal}>
                    Please confirm the creation of invoice correction for invoice {invoice && <span>{invoice.referenceNumber}</span>}
                </ConfirmationModal>

                <Row>
                    <Column size={12}>
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={showConfirmationModal}
                        >
                            create correction
                        </button>
                    </Column>
                    <Column size={12}>
                        <table className="default-table">
                            <thead>
                                <tr>
                                    <th>Position</th>
                                    <th>Original Price</th>
                                    <th>Refund amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoice.invoiceItemList.map(invoiceItem => {
                                    return (
                                        <InvoiceItemCorrectionForm
                                            key={invoiceItem.id}
                                            changeInvoiceCorrectionItem={changeInvoiceCorrectionItem}
                                            invoiceItem={invoiceItem}/>)
                                })}
                            </tbody>
                        </table>
                    </Column>
                </Row>
                <Row>
                    <Column size={12}>
                        <LabelInput label="Comment">
                            <TextArea name="customText" object={invoiceCorrectionData} onChange={changeInvoiceCorrectionData}/>
                        </LabelInput>
                    </Column>
                </Row>
            </ContentBox>
        </BlockUi>
    )
}


InvoiceCorrectionForm.propTypes = {
    invoice: PropTypes.object.isRequired,
    invoiceCorrectionData: PropTypes.object.isRequired,
    confirmationModalOpen: PropTypes.bool.isRequired,
    changeInvoiceCorrectionItem: PropTypes.func.isRequired,
    showConfirmationModal: PropTypes.func.isRequired,
    closeConfirmationModal: PropTypes.func.isRequired,
    createInvoiceCorrection: PropTypes.func.isRequired,
    changeInvoiceCorrectionData: PropTypes.func.isRequired,
}


export default InvoiceCorrectionForm




// WEBPACK FOOTER //
// ./src/modules/invoice/component/correction/InvoiceCorrectionForm.js